import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import "./assets/styles/main.scss";
import DashBoard from "./pages/Dashboard";
import LayoutComponent from "./components/layout/LayoutComponent";
import UserList from "./components/layout/UsersList";
import ChangePassword from "./components/auth/ChangePassword";
import ForgotPassword from "./pages/auth/ForgotPassword";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { VerifyToken } from "./pages/auth/VerifyToken";
import { fetchCurrentUser } from "./store/userSlice";
import RoleManage from "./components/layout/RoleManage";
import LeadManage from "./components/layout/LeadManage";
import MyProfile from "./pages/auth/MyProfile";
import PlatformManage from "./components/layout/PlatformManage";
import SettingsManage from "./components/layout/SettingsManage";
import { setNavigateFunction } from "./utils/axiosInstance";
import PrivateRoute from "./components/layout/private/Private";
// import { fetchPermissions } from "./store/roleSlice";
import { AVAILABLE_USER_PERMISSION, LANDING_PAGE_DETAILS } from "./utils/constant";
import TermsAndConditions from "./components/Common/TermsAndConditions";
import DomainManage from "./components/layout/ManageDomain";
import IndustryManage from "./components/layout/ManageIndustry";
import ClientManage from "./components/layout/ManageClient";
import ManageLeadPreview from "./components/layout/ManageLeadPreview";
import CookieManage from "./components/layout/CookieManage";
import SettingsLayout from "./components/layout/SettingsLayout";
import LandingPage from "./pages/Landing/Landing";
import ManageManualLead from "./components/layout/ManualLeadManage";
import ContactLeadManage from "./components/layout/ContactLeadManage";
import ManageLandingPage from "./components/layout/ManageLandingPage";
import { fetchDomains } from "./store/domainSlice";
import ImportDomainLogManage from "./components/layout/ImportDomainLogs";
import axios from "axios";
import PrivacyPolicy from "./components/Common/PrivacyPolicy";
import YoutubeManage from "./components/layout/YoutubeManage";
import InstagramManage from './components/layout/InstagramManage'
import RedditManage from './components/layout/RedditManage'
import AIContentManage from "./components/layout/AIContentManage";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('userAuthToken'))
  const userData = useSelector(state => state.userReducer.userData)
  const userPermissions = useSelector(state => state.userReducer.userPermission)
  // const domains = useSelector(state => state.domainReducer.domains)
  const landingPages = useSelector(state => state.landingPageReducer.landingPages)
  const requiredPermissions = useSelector(state => state.userReducer.permission)
  // const userPermission = useSelector((state) => state.userReducer.userPermission)
  const domianPermissions = userPermissions.find((perm) => perm.model_name === "domain")?.permissions || [];
  let canView = domianPermissions.includes("view");
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [domains, setDomains] = useState([]);
  const location = useLocation();
  const excludePaths = ['/login', '/register', '/reset-password', '/forgot-password', '/terms-conditions', '/privacy-policy'];

  useEffect(() => {
    setNavigateFunction(navigate);
  }, [navigate]);

  useEffect(() => {

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/domain/public-domains`, {
      refresh: localStorage.getItem('refreshToken'),
    }).then((response) => {
      // console.log("response domain", response);
      if (response.status === 200) {
        setDomains(response?.data?.data)
      }
    }).catch((error) => {
    })

  }, [])
  useEffect(() => {
    if (!excludePaths.includes(location.pathname)) {
      dispatch(fetchCurrentUser());
    }
    // dispatch(fetchCurrentUser())

  }, [])

  // console.log("isAuthenticated",isAuthenticated);


  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        draggable
      />
      <Routes>
        <Route path="/" element={isAuthenticated ? <LayoutComponent setIsAuthenticated={setIsAuthenticated} /> : <Navigate to="/login" />} >
          {/* <Route path="/" element={<LayoutComponent  />} > */}
          {/* Protected Routes */}
          <Route
            element={
              <PrivateRoute
                userPermissions={userPermissions}
                requiredPermissions={[]}
              />
            }
          >
            <Route path="/" element={<DashBoard />} />
          </Route>
          <Route
            element={
              <PrivateRoute
                isAuthenticated={isAuthenticated}
                userPermissions={userPermissions}
                requiredPermissions={[AVAILABLE_USER_PERMISSION.USERS]}
              />
            }
          >
            <Route path="/users" element={<UserList />} />
          </Route>
          <Route
            element={
              <PrivateRoute
                isAuthenticated={isAuthenticated}
                userPermissions={userPermissions}
                requiredPermissions={[AVAILABLE_USER_PERMISSION.ROLES]}
              />
            }
          >
            <Route path="/roles" element={<RoleManage />} />
          </Route>
          <Route
            element={
              <PrivateRoute
                isAuthenticated={isAuthenticated}
                userPermissions={userPermissions}
                requiredPermissions={[]}
              />
            }
          >
            <Route path="/ai-content" element={<AIContentManage />} />
          </Route>
          <Route
            element={
              <PrivateRoute
                isAuthenticated={isAuthenticated}
                userPermissions={userPermissions}
                requiredPermissions={[AVAILABLE_USER_PERMISSION.LEADS]}
              />
            }
          >
            <Route path="/preview" element={<ManageLeadPreview />} />
            <Route path="/leads" element={<ContactLeadManage />} />
            <Route path="/leads/scrapped" element={<LeadManage />} />
            <Route path="/leads/organic" element={<ManageManualLead />} />
            <Route path="/leads/hot-leads" element={<ContactLeadManage />} />
          </Route>
          <Route
            element={
              <PrivateRoute
                isAuthenticated={isAuthenticated}
                userPermissions={userPermissions}
                requiredPermissions={[AVAILABLE_USER_PERMISSION.GLOBAL_SETTING]}
              />
            }
          >
            <Route path="/settings" element={<SettingsLayout />} />
            <Route path="/settings/global" element={<SettingsManage />} />
            <Route path="/settings/facebook" element={<CookieManage />} />
            <Route path="/settings/instagram" element={<InstagramManage />} />
            <Route path="/settings/reddit" element={<RedditManage />} />
            <Route path="/settings/youtube" element={<YoutubeManage />} />
            <Route path="/settings/landing-page" element={<ManageLandingPage />} />
          </Route>
          <Route
            element={
              <PrivateRoute
                isAuthenticated={isAuthenticated}
                userPermissions={userPermissions}
                requiredPermissions={[AVAILABLE_USER_PERMISSION.GLOBAL_SETTING]}
              />
            }
          >
            <Route path="/domain" element={<DomainManage />} />
            <Route path="/domain/import-logs" element={<ImportDomainLogManage />} />
          </Route>
          <Route
            element={
              <PrivateRoute
                isAuthenticated={isAuthenticated}
                userPermissions={userPermissions}
                requiredPermissions={[AVAILABLE_USER_PERMISSION.GLOBAL_SETTING]}
              />
            }
          >
            <Route path="/industry" element={<IndustryManage />} />
          </Route>
          <Route
            element={
              <PrivateRoute
                isAuthenticated={isAuthenticated}
                userPermissions={userPermissions}
                requiredPermissions={[AVAILABLE_USER_PERMISSION.GLOBAL_SETTING]}
              />
            }
          >
            <Route path="/client" element={<ClientManage />} />
          </Route>

          <Route
            element={
              <PrivateRoute
                isAuthenticated={isAuthenticated}
                userPermissions={userPermissions}
                requiredPermissions={[AVAILABLE_USER_PERMISSION.PLATFORM]}
              />
            }
          >
            <Route path="/platform" element={<PlatformManage />} >
            </Route>
            <Route path="/profile" element={<MyProfile />} />
            <Route path="/change-password" element={<ChangePassword />} />
          </Route>
        </Route>
        {domains?.map((land) => {
          return (<Route path={`/public/${land?.slug}`} element={<LandingPage pageDetail={land} />} />)
        })}
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<VerifyToken />} />
        <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </>
  );
}

export default App;
